export default __webpack_public_path__ + "static/KeywordResearch_02_02-1cb1839cc0a987ad1f5e868e64e01c6c.webp";